module.exports = __webpack_public_path__ + "img/lv7.62da4719.png";